export default {
	curindex: (state) => {
		return state.curindex
	},
	shownav: (state) => {
		return state.isNavShow
	},
	login: (state) => {
		return state.isLogin
	},
	starnum: (state) => {
		return state.starnum
	},
	focusnum: (state) => {
		return state.focusnum
	},
	fannum: (state) => {
		return state.fannum
	},
	fabunum: (state) => {
		return state.fabunum
	},
	sellnum: (state) => {
		return state.sellnum
	},
	buynum: (state) => {
		return state.buynum
	},
	likenum: (state) => {
		return state.likenum
	},
	money: (state) => {
		return state.money
	},
	username: (state) => {
		return state.username
	},
	goodstitle: (state) => {
		return state.goodstitle
	},
	goodsinfo: (state) => {
		return state.goodsinfo
	},
	primecost: (state) => {
		return state.primecost
	},
	freight: (state) => {
		return state.freight
	},
	news: (state) => {
		return state.news
	},
  db:(state) => {
	  return state.db
  },
  websocket:(state) =>{
	  return state.websocket;
  },
  token:(state)=>{
	  return state.token;
  },
  pages:(state)=>{
	  return state.pages;
  },
  isAddPage:(state)=>{
	  return state.isAddPage;
  },
  price:(state) => {
    return state.price;
  },
  brand:(state) => {
    return state.brand;
  },
  carForme:(state)=>{
	  return state.carForme
  },
  borneMill:(state)=>{
	  return state.borneMill
  },
  carAge:(state)=>{
	  return state.carAge
  },
  displacement:(state)=>{
	  return state.displacement
  },
  fuelType:(state)=>{
	  return state.fuelType
  },
  seatNum:(state)=>{
	  return state.seatNum
  },
  chatMsg:(state) =>{
	  return state.chatMsg;
  },wChatUserId:(state)=>{
    return state.wChatUserId;
  },sendSingleMsgUnsucce:(state) =>{
	  return state.sendSingleMsgUnsucce;
  },sendSingleMsgUnerror:(state) =>{
	  return state.sendSingleMsgUnerror;
  },audio:(state)=>{
	  return state.audio;
  },chatMsgs:(state)=>{
	  return state.chatMsgs;
  },dtask:(state)=>{
    return state.dtask;
  },downTotal:(state)=>{
    return state.downTotal;
  },carUserId:(state)=>{
	  return state.carUserId
  },zhouseTypeIndex:(state)=>{
    return state.zhouseTypeIndex
  },zhouseId:(state)=>{
	  return state.zhouseId
  },oldCurrAddr:(state)=>{
    return state.oldCurrAddr
  },currAddr:(state)=>{
    return state.currAddr
  },pageTag:(state)=>{
	  return state.pageTag
  },find:(state)=>{
    return state.find
  },lat:(state)=>{
    return state.lat
  },lgt:(state)=>{
    return state.lgt
  },wx:(state)=>{
    return state.wx
  },chatMsgNum:(state)=>{
	  return state.chatMsgNum
  }
}



// WEBPACK FOOTER //
// ./src/store/getter.js